const trendsFR = {
    "view": {
        "form": {
            "label": {
                "filters": "Filtres",
                "period": "Période",
                "store": "Magasin",
                "label": "Label",
                "release": "Sortie",
                "track": "Piste",
                "subuser": "Sous-utilisateur",
                "fetchingTrends": "Récupération des tendances depuis la base de données"
            },
            "button": {
                "resetFilters": "Réinitialiser les filtres"
            },
            "options": {
                "store": {
                    "allStores": "Tous les magasins",
                    "downloadStores": "Magasins de téléchargement",
                    "streamingStores": "Magasins de streaming",
                    "streamStores": "Magasins de flux"
                },
                "label": {
                    "allLabels": "Tous les labels"
                },
                "release": {
                    "allReleases": "Toutes les sorties"
                },
                "track": {
                    "allTracks": "Toutes les pistes"
                },
                "subuser": {
                    "selectSubuser": "Sélectionner un sous-utilisateur"
                },
                "period": {
                    "last7Days": "Les 7 derniers jours",
                    "last14Days": "Les 14 derniers jours",
                    "last30Days": "Les 30 derniers jours",
                    "last45Days": "Les 45 derniers jours",
                    "last60Days": "Les 60 derniers jours",
                    "last75Days": "Les 75 derniers jours",
                    "last90Days": "Les 90 derniers jours"
                }
            }
        },
        "top10": {
            "title": "Top 10",
            "table": {
                "column": {
                    "artistName": "Artiste",
                    "songMixName": "Nom de la chanson/mix",
                    "numberOfSales": "Nombre de ventes"
                }
            }
        },
        "storeWiseSales": {
            "title": "Ventes par magasin",
            "label": {
                "amazonMusicStream": "Flux Amazon Music",
                "appleMusicStream": "Flux Apple Music",
                "beatportStream": "Flux Beatport",
                "deezerStream": "Flux Deezer",
                "facebookStream": "Flux Facebook",
                "instagramStream": "Flux Instagram",
                "itunesDownload": "Téléchargement iTunes",
                "pandoraStream": "Flux Pandora",
                "soundcloudStream": "Flux SoundCloud",
                "spotifyStream": "Flux Spotify",
                "tiktokStream": "Flux Tiktok",
                "traxsourceStream": "Flux Traxsource",
                "youtubeStream": "Flux Youtube",
                "youtubePremiumStream": "Flux Youtube Premium",
                "totalSales": "Ventes totales",
                "storeMessage": "* Les labels des magasins sont classés par ordre alphabétique (A-Z)"
            }
        },
        "salesByTerritory": {
            "title": "Ventes par territoire"
        },
        "salesByGender": {
            "title": "Ventes par genre",
            "label": {
                "male": "Homme",
                "female": "Femme",
                "nonBinary": "Non-binaire",
                "unknown": "Inconnu"
            }
        },
        "salesByAge": {
            "title": "Ventes par âge",
            "label": {
                "male": "Homme",
                "female": "Femme",
                "genderOther": "Non-binaire",
                "unknown": "Inconnu",
                "ageWiseSales": "Ventes par âge",
                "ageUnknown": "Âge inconnu"
            }
        },
        "message": {
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour profiter de cette fonctionnalité.",
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour profiter de cette fonctionnalité."
        }
    }
};

export default trendsFR;